import { applyFormat } from './applyFormat';
import { isBindMapRef, isBindRef } from './isBoundValue';
import { resolveFormatSpec } from './resolveFormatSpec';
import { resolvePath } from './resolvePath';
export { resolveFormatSpec } from './resolveFormatSpec';
function formatIfSpecified(resolved, format, namespaces, loopItem) {
  if (!format) return resolved;
  const resolvedFormat = resolveFormatSpec(format, namespaces, loopItem);
  if (!resolvedFormat) return resolved;
  return applyFormat(resolved, resolvedFormat, namespaces.system.locale);
}
function resolveBindMap(ref, namespaces, loopItem) {
  const base = resolvePath(ref.$bindMap.value, namespaces, loopItem);
  if (base === null || typeof base !== 'object') return undefined;
  const key = resolvePath(ref.$bindMap.key, namespaces, loopItem);
  if (key === undefined || key === null) return undefined;
  const stringKey = String(key);
  return Object.prototype.hasOwnProperty.call(base, stringKey) ? base[stringKey] : undefined;
}
export function resolveBindable(value, namespaces, loopItem) {
  if (value === undefined) return undefined;
  if (isBindMapRef(value)) {
    const resolved = resolveBindMap(value, namespaces, loopItem);
    return formatIfSpecified(resolved, value.$format, namespaces, loopItem);
  }
  if (isBindRef(value)) {
    const resolved = resolvePath(value.$bind, namespaces, loopItem);
    return formatIfSpecified(resolved, value.$format, namespaces, loopItem);
  }
  return value;
}
export function resolveBindableBoolean(value, namespaces, loopItem) {
  const raw = resolveBindable(value, namespaces, loopItem);
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return raw;
}